import {
  LOCAL_STORAGE_KEY_EVENTS_FILTERS,
  LOCAL_STORAGE_KEY_PORTAL_LAYOUT_FILTERS,
  LOCAL_STORAGE_KEY_PRODUCT_FILTERS,
} from '@/helpers/constants'
import { expandScormProductTypeFilter } from '@/helpers/products/productTypes/productTypeMappings'

export function useProductFilters() {
  type TypeSort = string
  type TypeSortDesc = boolean
  type TypeFiltersProductTypes = string[] | []
  type TypeFiltersPolicy = { name: string; id: string }
  type TypeFiltersContentStatus = {
    type: 'missing' | 'present'
    locale: { code: string; name: string }
  }
  type TypeFilters = {
    contentStatus?: TypeFiltersContentStatus
    policy?: TypeFiltersPolicy
    productTypes: TypeFiltersProductTypes
    productTagIds?: string[]
    published?: boolean
  }

  function numberOfActiveFilters(filters: TypeFilters) {
    let count = 0
    count += filters.contentStatus ? 1 : 0
    count += filters.policy ? 1 : 0
    count += filters.productTypes.length
    count += filters.productTagIds?.length ?? 0
    count += filters.published !== undefined ? 1 : 0
    return count
  }

  const getContentStatusFilterString = (
    filterContentStatus?: TypeFiltersContentStatus
  ) => {
    const type = filterContentStatus?.type
    const localeCode = filterContentStatus?.locale?.code

    if (type) {
      if (type && localeCode) {
        return `${type},${localeCode}`
      }
      return type
    }
    return undefined
  }

  const getProductTypesFilterString = (
    filterProductTypes: TypeFiltersProductTypes
  ) => {
    return filterProductTypes.length > 0
      ? expandScormProductTypeFilter(filterProductTypes.join())
      : undefined
  }

  const getSortString = (sort: TypeSort, sortDesc: TypeSortDesc) => {
    const sortDirection = sortDesc ? '-' : ''
    return `${sortDirection}${sort}`
  }

  const deleteLocalStorageProductFilters = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEY_PRODUCT_FILTERS)
    localStorage.removeItem(LOCAL_STORAGE_KEY_PORTAL_LAYOUT_FILTERS)
    localStorage.removeItem(LOCAL_STORAGE_KEY_EVENTS_FILTERS)
  }

  return {
    getSortString,
    getContentStatusFilterString,
    getProductTypesFilterString,
    numberOfActiveFilters,
    deleteLocalStorageProductFilters,
  }
}
